import React from 'react';
import { Box, Grid, Button } from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import useCustomers from './useCustomers';
import LoadingBackdrop from 'components/LoadingBackdrop';
import {
  CustomerSearch,
  CustomerList,
  CustomerFormUnified,
} from 'containers/pages/customers/components';

function Customers() {
  const { state, handler } = useCustomers();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Header row */}
      <Grid
        container
        alignItems="stretch"
        spacing={2}
        wrap="nowrap"
        sx={{ mb: 2 }}
      >
        {/* Left: New Customer button */}
        <Grid item>
          <Button
            variant="contained"
            startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
            onClick={handler.onToggleForm}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 2,
              height: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>NEW CUSTOMER</Box>
            <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>NEW</Box>
          </Button>
        </Grid>

        {/* Right: Search */}
        <Grid item xs>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CustomerSearch
              searchInput={state.searchInput}
              onSearchInput={handler.onSearchInput}
              onReset={handler.onResetSearch}
            />
          </Box>
        </Grid>
      </Grid>

      {/* Conditional add form */}
      {state.isOpenForm && (
        <CustomerFormUnified
          mode="add"
          customerTypes={state.customerTypes}
          onSave={handler.onSaveCustomer}
          onClose={handler.onToggleForm}
        />
      )}

      {/* Main customer list */}
      <CustomerList
        customers={state.searchedCustomers}
        customerTypes={state.customerTypes}
        onSave={handler.onSaveCustomer}
      />

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default Customers;
